/**
 * GridElement — F12.H T12.H.3.
 *
 * Siatka responsywna — N kolumn na desktop, fewer na mobile. Różni się
 * od ColumnsElement responsivnością (Columns ma stałą liczbę kolumn,
 * Grid degraduje na mobile).
 *
 * Settings: { colsDesktop?: 2|3|4|6, gap?: 'sm'|'md'|'lg' }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const RESPONSIVE_CLASS: Record<number, string> = {
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6',
};

const GAP_CLASS: Record<string, string> = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
};

export const GridElement: LayoutElementDefinition = {
  type: 'grid',
  category: 'kontenery',
  isContainer: true,
  label: 'Siatka',
  icon: 'LayoutGrid',
  defaultSettings: () => ({
    colsDesktop: 3,
    gap: 'md',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      colsDesktop?: number;
      gap?: 'sm' | 'md' | 'lg';
    };
    const cols = settings.colsDesktop ?? 3;
    const responsiveCls = RESPONSIVE_CLASS[cols] ?? RESPONSIVE_CLASS[3];
    const gapCls = GAP_CLASS[settings.gap ?? 'md'] ?? 'gap-3';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`grid ${responsiveCls} ${gapCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition rounded p-1' : ''}`}
        data-testid={`grid-element-${element.id}`}
        data-element-type="grid"
        data-cols-desktop={cols}
      >
        {children.length > 0 ? (
          children
        ) : isBuilder ? (
          <div className="col-span-full rounded border-2 border-dashed border-border-primary py-3 text-center text-xs text-text-muted">
            Siatka {cols}-kolumnowa (responsywna) — przeciągnij elementy
          </div>
        ) : null}
      </div>
    );
  },
};
